import { render, staticRenderFns } from "./TheOrder.vue?vue&type=template&id=9b89fb1e&"
import script from "./TheOrder.vue?vue&type=script&lang=js&"
export * from "./TheOrder.vue?vue&type=script&lang=js&"
import style0 from "./TheOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports